import { useChatContext } from './ChatContext';

const useConversation = () => {
    const { conversation } = useChatContext();
    return { conversation };
};

export default useConversation;
